export const mapAsync = (array, mapperFn) => {
  return Promise.all(array.map(mapperFn));
};

export const filterAsync = async (array, filterFn) => {
  const filterMap = await mapAsync(array, filterFn);
  return array.filter((value, index) => filterMap[index]);
};
